$(function () {
    let event = new Event('form-submit');

    function createRequest(formData, url, type) {
        return $.ajax({
            url: url,
            type: type,
            processData: false,
            contentType: false,
            data: formData
        });
    }

    function showError(element, errors) {
        let errorBlock = $(element).next('.landing__form-errors');
        errorBlock.text(errors[0]);
        errorBlock.removeClass('hide');

        if ($(element).attr('type') === 'file') {
            element = $(element).prev('.file-upload__input');
        }

        $(element).addClass('landing__form-input--has-errors');
    }

    let clickSend = false;
    $('#landing-form').on('submit', function() {
        if (clickSend) {
            return false;
        }
        clickSend = true;

        let form = $(this);
        let fbRequestName = 'AcademyFormRequest';
        let pathname = window.location.pathname;
        if (pathname) {
            pathname = pathname.replaceAll('/', '');
        }

        let specialization = pathname;
        if (!specialization) {
            specialization = 'manager';
        }
        $(form).find('#form-type-input').val(specialization);

        let formData = new FormData(form[0]);
        formData.append('specialization', specialization);

        let specializationType = specialization;
        let FBspecializationType = specialization;

        if (specialization === 'programmer') {
            specialization = 'developer'; //fb уже настроен на developer

            let select = document.getElementById('systemtype').options.selectedIndex;
            let selectOption = document.getElementById('systemtype').options[select].value;

            if (selectOption === 'backend') {
                specializationType = 'back-end';
                FBspecializationType = 'AcademyFormSendDeveloperBackend';
            } else if (selectOption === 'frontend') {
                specializationType = 'front-end';
                FBspecializationType = 'AcademyFormSendDeveloperFrontend';
            }
        }
        fbq('track', fbRequestName, { specialization, 'event': 'onclick' });

        let request = createRequest(
            formData,
            $(form).attr('action'),
            $(form).attr('method')
        ).always(function () {
            form.find('.landing__form-errors').addClass('hide').text('');
            form.find('input').removeClass('landing__form-input--has-errors');
        });

        request.done(function (result) {
            clickSend = false;

            if (result.error === false) {
                form.addClass('landing__form--sent');

                if (innerWidth < 992) {
                    $('html, body').scrollTop(form.offset().top - 10);
                }

                fbq('track', fbRequestName, { specialization, 'event': 'complete' });
                fbq('track', FBspecializationType);
                ym(85427272, 'reachGoal', specializationType);
                VK.Goal('submit_application');
                VK.Goal(specializationType);

                document.dispatchEvent(event);
            }

            form.find('input,textarea').val('');
        });

        request.fail(function(e) {
            clickSend = false;

            fbq('track', fbRequestName, { specialization, 'event': 'validation_error' });

            let data = JSON.parse(e.responseText);

            if (data.error === true) {

                let errors = data.content;

                if (typeof errors['error_title'] !== "undefined") {
                    showError(form.find('button[type=submit]'), errors['error_title']);
                }

                if (typeof errors['first-name'] !== 'undefined') {
                    showError(form.find('input[name=first-name]'), errors['first-name']);
                }

                if (typeof errors['last-name'] !== 'undefined') {
                    showError(form.find('input[name=last-name]'), errors['last-name']);
                }

                if (typeof errors['email'] !== 'undefined') {
                    showError(form.find('input[name=email]'), errors['email']);
                }

                if (typeof errors['phone'] !== 'undefined') {
                    showError(form.find('input[name=phone]'), errors['phone']);
                }

                if (typeof errors['city'] !== 'undefined') {
                    showError(form.find('input[name=city]'), errors['city']);
                }

                if (typeof errors['policy'] !== 'undefined') {
                    showError(form.find('input[name=policy]'), errors['policy']);
                }

                if (typeof errors['attached-file'] !== 'undefined') {
                    showError(form.find('input[name=attached-file]'), errors['attached-file']);
                }
            }

            form.removeClass('landing__form--sent');
        });

        return false;
    });
});
